var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"today-link cursor-pointer text-overline text-underline text-uppercase",class:_vm.classes,on:{"click":_vm.today}},[_vm._v(" Today ")])}
var staticRenderFns = []

export { render, staticRenderFns }